<template>
  <div>
    <base-header class="pb-6  bg-gradient-info">
    <div style="min-height:30px;"></div>
    

      
      
    </base-header>

    <!--start container-->
    <div class="container-fluid mt--6 ">
    	<div class="row">
    	
    		   <div class="col-xl-9">
      		
   			   <card type="default" class="text-white">
   			      <h5 slot="header" class="h3 mb-0">Check Availability Of Your Preferred Singapore Company Name </h5>
   			      <br/>
   			      For quick incorporation of your company, the name should:
   			   <br/><br/>
   			   	<ul>
   			   		<li> Not be the same or similar to an existing company's name. <br/><br/>
   			   		 Common words such as "the", "company", "Singapore", "Asia", "group" are usually ignored when deciding if two names 
   			   		are the same. For example, "Alpha" and  "Alpha Group" are considered to be the same name.<br/><br/><br/></li>
   			   		<li> Not be vulgar, obscene or offensive.</li>
   			   	
   			   	</ul>
   			   	<br/>
   			   	<br/>
   			   	<br/>
   			   	
   			   	<div style="text-align:center;font-size:12px;">This search is done using open-source data provided by the Singapore government 
   			   		and ACRA under the Singapore Open Data Licence.
   			   			<br/><br/> The data is updated periodically by ACRA and does not contain recently incorporated companies as well as selected companies.
   			   	</div>
   			   
   			   
   			   </card>
      			
          </div>
    	
    	
    	</div>
    
    	<div class="row">
    		
      	
      		<div class="col-xl-6" style="margin-top:20px;"> 
      		<card>
				<base-input  label="Preferred Company Name"   :rules="{required: true}" name="preferred company name" v-model="company.entity_name">
					  		    <small slot="append" class="font-weight-bold">Pte Ltd</small>
				</base-input>
				
				  <base-button block type="primary" @click.prevent="searchName">Search</base-button>
				  </card>
				</div>
      	
      		
      	
    	</div>
    	
    
      <div class="row">
      	
      
       <div class="col-xl-12">
      
       	<card>
       	
    
    	  <base-alert v-if="exactMatch==1"  type="warning" icon="ni ni-like-2">
           <i class="fa fa-exclamation-triangle"></i>  Oops! There is a company with the same name. Please choose another name.
    	 </base-alert>	
    	 
    	   <base-alert v-if="searchDone && numResults>100"  type="warning" icon="ni ni-like-2">
           <i class="fa fa-exclamation-triangle"></i> This name is too common and might not be available, try to be more precise when searching.
    	 </base-alert>	
    	  <base-alert v-else-if="searchDone && exactMatch==0 && records.length!=0"  type="success" icon="ni ni-like-2">
           <i class="fa fa-check-circle"></i> This name is likely to be available.
    	 </base-alert>
    	 
    	    <base-alert v-if="searchDone && records.length==0"  type="success" icon="ni ni-like-2">
           <i class="fa fa-check-circle"></i>  No matching results. Your preferred name should be available!
    	 </base-alert>	
    	 
      
        <el-table v-if="records.length>0" class="table-responsive table-flush"
                  header-row-class-name="thead-light"
                  :data="records">
                  
             <el-table-column label="Similarity"
                             min-width="50px"
                             >
                    <template slot-scope="scope">
                    	<div style="color:red;font-weight:bold;" v-if="scope.row.percent==100">
                    		Exact
                    	</div>
                    	
                    	<div style="" v-else>
                    		{{scope.row.percent_str}}%
                    	</div>
                    </template>
            </el-table-column>
                  
            <el-table-column label="Company Name"
                             prop="entity_name"
                             min-width="240px"
                             >
                    <template slot-scope="scope">
                    	<div style="color:#000;font-weight:bold;">{{scope.row.entity_name}}</div>
                    </template>
            </el-table-column>
		     <el-table-column label="UEN"
                             prop="uen"
                             min-width="120px"
                             >
            </el-table-column>
            

            
             <el-table-column label="Company Status" >
                	<template slot-scope="scope">
                	  <span v-if="scope.row.uen_status=='R'">
                	  LIVE
                	  </span>
                	  <span v-else>Deregistered</span>
          			</template>
        	</el-table-column>
        	  <el-table-column label="Date Issued"
                             prop="uen_issue_date"
                             min-width="120px"
                             >
            </el-table-column>
        	
          
        </el-table>
      	</card>
      
         
        </div>
       <!-- end column --> 
    

       
      </div>
      <!-- End row-->

      <!--start new row-->
     




    
    </div>  <!--End container-->
    
    
    <div style="min-height:200px;"></div>

  </div>
</template>
<script>
  import { Table, TableColumn, Tabs, TabPane,} from 'element-ui'
  import ApiService from '@/services/api.service';
  import { TokenService } from '@/services/storage.service'
  import swal from 'sweetalert2';
  import 'sweetalert2/dist/sweetalert2.css';

  export default {
    components: {
  		  [Table.name]: Table,
      	[TableColumn.name]: TableColumn,
     	 TabPane,
     	 Tabs,
    },
    data() {
      return {
      	 searchDone: 0,
      	 exactMatch: 0,
      	 numResults:0,
     	 records:[],
     	 company:{
     	 	"entity_name":'',
     	 },
	
      };
    },
    methods: {
      searchName() {
      		swal.showLoading();
     	let uri = this.$base_url+'/api/v1/c/get_name_checker';
         ApiService.post(uri, this.company).then(response => {
         	 this.records = response.data.results;
      		 const vm = this;
      		 this.searchDone = 1;
      		 this.exactMatch = response.data.exactMatch;
      		 this.numResults = response.data.numResults;
      		 swal.close();
   
      	})

      }
    },
    mounted() {
      
      	
      	
    }
  };
</script>
<style lang="scss">
@media screen and (max-width: 820px) {
	.ec_company_header_mob{
		display:none;
	}	
}



</style>














